<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">A work such as this could not have been produced apart from the knowledge and insights of former teachers; numerous authors, both classical and contemporary; and the editorial assistance of Austin Macauley Publishers. To them, the author owes a debt of gratitude.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?59c02505